/**
 * Uncomment this only if you have js functionality for the component
 * 
 */

// Check if component is added to the page
 if( jQuery('section.columns').length ) {
     
    equalHeightBorderTitles();

}

jQuery(document).on('ready', function () {
    // Check if component is added to the page
    if( jQuery('section.columns').length ) {
        // Remove border-top for columns without heading on mobile
        jQuery("section.columns .column.border-top:has(.heading-empty)").addClass('mobile-remove-border-top');
        equalHeightBorderTitles();
    }
});

var resizeDelay;
jQuery( window ).resize(function() {
    // Check if component is added to the page
    if( jQuery('section.columns').length ) {

        clearTimeout(resizeDelay);
        resizeDelay = setTimeout(equalHeightBorderTitles(), 100);

    }
});

function equalHeightBorderTitles() {
    // --------------------------------------------------
    // Headings must have "box-sizing: content-box;"
    // --------------------------------------------------
    // Mark sections with border titles
    jQuery('.column.border-top').parents('section.columns').addClass('section-border-titles');
    // Each column with border titles
    jQuery('.section-border-titles').each(function() {
        var section = jQuery(this);
        var rowNo = 1;
        var columnNo = 1;
        var borderTitlesHeight = 0;
        // Reset current heights
        section.find('.column.border-top .heading').removeAttr('style');
        // Each border title height
        section.find('.column.border-top .heading').each(function() {
            // Set row number to column
            jQuery(this).parents('.column').attr('data-row-no', rowNo);
            // Column heading height
            var headingHeight = jQuery(this).height();
            if( headingHeight > borderTitlesHeight ) {
                // Set current heading height as biggest
                borderTitlesHeight = headingHeight;
            }
            // Set headings height for current row
            if(columnNo == 3) {
                section.find(".column.border-top[data-row-no="+rowNo+"] .heading").css({ 'height': borderTitlesHeight+'px' });
                // Next row
                rowNo++;
                // Reset
                columnNo = 1;
                borderTitlesHeight = 0;
            } else {
                columnNo++;
            }
        });
    });
}